import { Component, OnInit } from '@angular/core';
import { RdsModule } from '@rabobank/rds-angular';

import { ToastrService } from '../../services/toastr.service';

@Component({
  selector: 'app-toastr',
  imports: [RdsModule],
  templateUrl: './toastr.component.html',
  styleUrl: './toastr.component.scss',
})
export class ToastrComponent implements OnInit {
  message: string = '';
  show: boolean = false;
  type: 'success' | 'error' = 'success';

  constructor(private toastrService: ToastrService) {}

  ngOnInit(): void {
    this.toastrService.toastrState.subscribe((state) => {
      this.message = state.message;
      this.type = state.type;
      this.show = true;
      setTimeout(() => {
        this.show = false;
      }, 5000);
    });
  }
}
